
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private-events/gallery",
      function () {
        return require("private-next-pages/private-events/gallery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/private-events/gallery"])
      });
    }
  